module.exports = __webpack_public_path__ + "static/media/momPillow.e78e3cf8.jpg";